export default{
    msg:'',
    editar:{},
    lista:'',
    trabalhadores:'',
    salariobase:''
}